// extracted by mini-css-extract-plugin
export default {"wrapper":"PasswordInput_wrapper__2KyjA"};